module.exports = __webpack_public_path__ + "img/hoozieRewardsPhone.895203b1.svg";